import jQuery from 'jquery';

jQuery(function ($) {
    'use strict';

    // Show appropriate text for the selected amount
    $('.cta-donate').each(function () {
        const $container = $(this);
        const $tabButtons = $container.find('[role="tab"]');
        const $tabPanels = $container.find('[role="tabpanel"]');
        const $amountInput = $container.find('#cta-donate__amount');

        const setHiddenInputDisabled = function ($btn, disabled) {
            const hiddenId = $btn.attr('data-hidden-input');
            if (hiddenId) {
                $('#' + hiddenId).prop('disabled', disabled);
            }
        };

        $tabButtons.each(function () {
            const $btn = $(this);
            const $tab = $('#' + $btn.attr('aria-controls'));
            const isActive = $btn.attr('aria-selected') === 'true';

            if (isActive) {
                $btn.removeAttr('tabIndex');
                setHiddenInputDisabled($btn, false);
                $tab.removeClass('hide');
            } else {
                $btn.attr('tabIndex', -1);
                setHiddenInputDisabled($btn, true);
                $tab.addClass('hide');
            }
        });

        const makeActive = function ($el) {
            const $tab = $('#' + $el.attr('aria-controls'));

            $tabButtons.each(function () {
                const $btn = $(this);
                $btn.attr('tabIndex', -1);
                $btn.attr('aria-selected', 'false');
                setHiddenInputDisabled($btn, true);
            });
            $tabPanels.addClass('hide');

            $el.attr('aria-selected', 'true');
            $el.removeAttr('tabindex');
            setHiddenInputDisabled($el, false);
            $tab.removeClass('hide');

            // Set first option as selected
            $tab.find('input[type="radio"]').first().prop('checked', true).change();
        };

        const updateRecurringLink = function ($el) {
            // Update recurring donation link with new amount
            const $tab = $el.closest('[role="tabpanel"]');
            if ($tab.length && $tab.attr('id').includes('recurring')) {
                const $link = $container.find('.external-donation');
                const defaultURL = $link.data('default');
                $link.attr('href', defaultURL + `?amount=${$el.val()}`);
            }
        };

        $tabButtons.on('click focus', function () {
            makeActive($(this));
        });

        $tabButtons.on('keydown', function (e) {
            e.preventDefault();
            // Focus first available amount if tab pressed
            if (e.key === 'Tab' || (e.which === 9 && $(this).is(':focus'))) {
                $('.cta-donate__amounts:visible input').first().focus();
            }
        });

        $tabButtons.on('keyup', function (e) {
            e.preventDefault();
            // Go to next tab on space or right arrow press
            if (
                e.key === ' ' ||
                e.key === 'Spacebar' ||
                e.which === 32 ||
                e.key === 'ArrowRight' ||
                e.which === 39
            ) {
                let $nextTab = $(this).next();
                if (!$nextTab.length) {
                    $nextTab = $tabButtons.first();
                }
                if ($(this).attr('aria-selected') === 'false') {
                    makeActive($(this));
                } else {
                    makeActive($nextTab);
                }
            }
            // Go to next tab on left arrow press
            if (e.key === 'ArrowLeft' || e.which === 37) {
                let $prevTab = $(this).prev();
                if (!$prevTab.length) {
                    $prevTab = $tabButtons.last();
                }
                if ($(this).attr('aria-selected') === 'false') {
                    makeActive($(this));
                } else {
                    makeActive($prevTab);
                }
            }
        });

        $tabPanels.each(function () {
            const $panel = $(this);
            const $amounts = $panel.find('.cta-donate__amounts input[type="checkbox"]');
            const $customAmount = $panel.find('.cta-donate__amounts .custom-amount');

            $amounts.on('change', function () {
                if ($(this).is(':checked')) {
                    $amounts.not($(this)).prop('checked', false);
                    $customAmount.removeClass('active').find('input').val('');
                    $panel.find('.cta-donate__amount-text p').removeClass('active');
                    $panel
                        .find(
                            '.cta-donate__amount-text p:eq(' + $(this).closest('li').index() + ')',
                        )
                        .addClass('active');
                    $amountInput.val($(this).val());

                    updateRecurringLink($(this));
                } else {
                    $(this).prop('checked', true);
                }
            });

            $customAmount.on('click', function () {
                $(this).addClass('active');
                $amounts.prop('checked', false);
                $panel.find('.cta-donate__amount-text p').removeClass('active');
                $panel.find('.cta-donate__amount-text p.custom').addClass('active');
                $amountInput.val($(this).find('input').val());
            });

            $customAmount.find('input').on('input change', function () {
                $customAmount.addClass('active');
                $amounts.prop('checked', false);
                $panel.find('.cta-donate__amount-text p').removeClass('active');
                $panel.find('.cta-donate__amount-text p.custom').addClass('active');
                $amountInput.val($(this).val());
                updateRecurringLink($(this));
            });
        });
    });
});
